import "babel-polyfill";

import d3 from "d3";
const queue = require("d3-queue");

require("moment");
const moment = require("moment-timezone");
window.moment = moment;
const TIMEZONE = moment.tz.guess();


const CASES_ENDPOINT = "https://extranet.who.int/maps/rest/services/POLIOWEBSITE/Poliowebsite_layers/MapServer/0/query?where=1%3D1&outFields=Admin0%2C+IndicatorCode%2C+PeriodStartDate%2C+PeriodEndDate&returnGeometry=false&f=json";
//const WPV_INDICATOR_CODE = "WPV_CASE";
//const CVDPV_INDICATOR_CODE = "VDPV_CASE";
//For the previous year's data, we use a different indicator
const WPV_INDICATOR_CODE = {
  current_year: "WPV_CASE",
  previous_year: "WPV_CASE_YTD_PY"
};
const CVDPV_INDICATOR_CODE = {
  current_year: "VDPV_CASE",
  previous_year: "cVDPV_CASE_YTD_PY"
};

const container = d3.select(".polio-this-week");

queue.queue()
  .defer(d3.json, CASES_ENDPOINT)
  .defer(d3.csv, STAMEN_MAPS_CONFIG["polio_this_week"]["country_types"])
  .await((err, results, countryTypesCSV) => {
    if (err) {
      throw err;
    }

    const cases = results.features.map(f => {
      return {
        ...f.attributes,
        PeriodEndDate: moment.utc(f.attributes.PeriodEndDate),
        PeriodStartDate: moment.utc(f.attributes.PeriodStartDate),
      };
    });

    let types = {};
    const countryTypes = countryTypesCSV.reduce(function(obj, country) {
      obj[country.country] = {};
      obj[country.country].url = country.url;
      obj[country.country].type = country.category;

      types[country.category] = true;

      return obj;
    }, {});

    types = Object.keys(types);
    
		/*
			(Changed all Date instances to use Moment instead to make timezones consistent. UTC will always be displayed. - SB 2018413)
		*/

    const today = moment.utc();
    const CURRENT_YEAR_STRING_INT = moment.utc().year();
    
    // These are the ranges we use for the three time periods.
    // The first date is just a year, the second one is a full year-month-day
    const currentYearToDate = [
      moment([CURRENT_YEAR_STRING_INT, 0, 1]).utc(),
      moment.utc()
    ];
		window.currentYearToDate = currentYearToDate;
    const previousYearToDate = [
      moment([CURRENT_YEAR_STRING_INT - 1, 0, 1]).utc(),
      moment.utc()
    ];

    const previousYear = [
      moment([CURRENT_YEAR_STRING_INT - 1, 0, 1]).utc(),
      moment([CURRENT_YEAR_STRING_INT - 1, 11, 31]).utc()
    ];

    const countriesByType = Object.keys(countryTypes).reduce((obj, name) => {
      const attrs = countryTypes[name];

      obj[attrs.type] = obj[attrs.type] || [];
      obj[attrs.type].push(name);

      return obj;
    }, {});

    const ranges = {
      ["Year-to-date " + today.year()]: currentYearToDate,
      ["Year-to-date " + (today.year() - 1)]: previousYearToDate,
      ["Total in " + (today.year() - 1)]: previousYear
    };

		console.log('updated 20180416-1');

    const classificationGridHeaders = [
      ["Total cases"].concat(Object.keys(ranges)),
      Object.keys(ranges).reduce((arr, rangeName) => arr.concat(["WPV", "cVDPV"]), []),
    ];

    container
      .append("h2")
      .append("strong")
      .text("Wild poliovirus type 1 and Circulating vaccine-derived poliovirus cases");

    const classificationTable = container.append("table");

    classificationTable
      .append("thead")
      .selectAll("tr")
      .data(classificationGridHeaders)
      .enter()
        .append("tr")
        .selectAll("th")
        .data((d, i) => d.map(x => {
          return {
            title: x,
            colspan: x !== "Total cases" && i === 0 ? 2 : 1,
            rowspan: x === "Total cases" ? 2 : 1,
          };
        }))
        .enter()
          .append("th")
          .attr("colspan", d => d.colspan)
          .attr("rowspan", d => d.rowspan)
          .text(d => d.title);

    const classificationGridBody = [
      ["Globally"].concat(Object.keys(ranges).reduce((arr, rangeName) => {
        const range = ranges[rangeName];

        const inRange = cases
          .filter(x => {
	          return x.PeriodStartDate.isBetween(range[0], range[1], 'day', '[]') &&
		          x.PeriodEndDate.isBetween(range[0], range[1], 'day', '[]');
          });

        var wpv_indicator_code = WPV_INDICATOR_CODE.current_year;
        var cvdpv_indicator_code = CVDPV_INDICATOR_CODE.current_year;
        if ("Year-to-date " + (today.year() - 1) == rangeName) {
          wpv_indicator_code = WPV_INDICATOR_CODE.previous_year;
          cvdpv_indicator_code = CVDPV_INDICATOR_CODE.previous_year;
        }
        return arr.concat([wpv_indicator_code, cvdpv_indicator_code].map(indicatorCode => {
          return inRange.filter(x => x.IndicatorCode === indicatorCode);
        }).map(x => x.length));
      }, [])),
      ["&mdash;in endemic countries"].concat(Object.keys(ranges).reduce((arr, rangeName) => {
        const range = ranges[rangeName];
        const inRange = cases
          .filter(x => countriesByType["endemic"].indexOf(x.Admin0) >= 0)
          .filter(x => {
	          return x.PeriodStartDate.isBetween(range[0], range[1], 'day', '[]') &&
		          x.PeriodEndDate.isBetween(range[0], range[1], 'day', '[]');
          });

        var wpv_indicator_code = WPV_INDICATOR_CODE.current_year;
        var cvdpv_indicator_code = CVDPV_INDICATOR_CODE.current_year;
        if ("Year-to-date " + (today.year() - 1) == rangeName) {
          wpv_indicator_code = WPV_INDICATOR_CODE.previous_year;
          cvdpv_indicator_code = CVDPV_INDICATOR_CODE.previous_year;
        }
        return arr.concat([wpv_indicator_code, cvdpv_indicator_code].map(indicatorCode => {
          return inRange.filter(x => x.IndicatorCode === indicatorCode);
        }).map(x => x.length));
      }, [])),
      ["&mdash;in non-endemic countries"].concat(Object.keys(ranges).reduce((arr, rangeName) => {
        const range = ranges[rangeName];
        const inRange = cases
          .filter(x => countriesByType["endemic"].indexOf(x.Admin0) < 0)
          .filter(x => {
	          return x.PeriodStartDate.isBetween(range[0], range[1], 'day', '[]') &&
		          x.PeriodEndDate.isBetween(range[0], range[1], 'day', '[]');
          });

        var wpv_indicator_code = WPV_INDICATOR_CODE.current_year;
        var cvdpv_indicator_code = CVDPV_INDICATOR_CODE.current_year;
        if ("Year-to-date " + (today.year() - 1) == rangeName) {
          wpv_indicator_code = WPV_INDICATOR_CODE.previous_year;
          cvdpv_indicator_code = CVDPV_INDICATOR_CODE.previous_year;
        }
        return arr.concat([wpv_indicator_code, cvdpv_indicator_code].map(indicatorCode => {
          return inRange.filter(x => x.IndicatorCode === indicatorCode);
        }).map(x => x.length));
      }, [])),
    ];

    // I can't figure out https://github.com/stamen/who-gpei/issues/120 so this is a desperate patch
    if(classificationGridHeaders[0][3] == 'Total in 2015' && classificationGridBody[0][5] == '73')
      classificationGridBody[0][5] == '74';
    if(classificationGridHeaders[0][3] == 'Total in 2015' && classificationGridBody[1][5] == '73')
      classificationGridBody[1][5] == '74';

    classificationTable
      .append("tbody")
      .selectAll("tr")
      .data(classificationGridBody)
      .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
          .append("td")
          .html(d => d);

    const countryGridHeaders = [
      ["Countries"].concat(Object.keys(ranges).concat("Onset of paralysis of  most  recent case")),
      Object.keys(ranges).concat("").reduce((arr, _) => arr.concat(["WPV", "cVDPV"]), []),
    ];

    container
      .append("h2")
      .append("strong")
      .text("Case breakdown by country");

    const countryTable = container.append("table");

    countryTable
      .append("thead")
      .selectAll("tr")
      .data(countryGridHeaders)
      .enter()
        .append("tr")
        .selectAll("th")
        .data((d, i) => d.map(x => {
          return {
            title: x,
            colspan: x !== "Countries" && i === 0 ? 2 : 1,
            rowspan: x === "Countries" ? 2 : 1,
          };
        }))
        .enter()
          .append("th")
          .attr("colspan", d => d.colspan)
          .attr("rowspan", d => d.rowspan)
          .text(d => d.title);


    const formatDate = date => {
      if (date === -Infinity) {
        return "NA";
      }
			
			return moment.utc(date).format('D-MMM-YYYY');
    };

    const countryGridBody = Object.keys(countryTypes)
      .filter(country => {
        return cases.filter(x => country === x.Admin0).length > 0;
      })
      .sort()
      .map(country => {
        const byCountry = cases.filter(x => country === x.Admin0);

        const lastWPV = Math.max.apply(null, byCountry
          .filter(x => x.IndicatorCode === WPV_INDICATOR_CODE.current_year)
          .map(x => x.PeriodStartDate));

        const lastCVDPV = Math.max.apply(null, byCountry
          .filter(x => x.IndicatorCode === CVDPV_INDICATOR_CODE.current_year)
          .map(x => x.PeriodStartDate));

        return [country.toLowerCase()].concat(Object.keys(ranges).reduce((arr, rangeName) => {
          const range = ranges[rangeName];
          const inRange = byCountry
            .filter(x => {
		          return x.PeriodStartDate.isBetween(range[0], range[1], 'day', '[]') &&
			          x.PeriodEndDate.isBetween(range[0], range[1], 'day', '[]');
            });

          var wpv_indicator_code = WPV_INDICATOR_CODE.current_year;
          var cvdpv_indicator_code = CVDPV_INDICATOR_CODE.current_year;
          if ("Year-to-date " + (today.year() - 1) == rangeName) {
            wpv_indicator_code = WPV_INDICATOR_CODE.previous_year;
            cvdpv_indicator_code = CVDPV_INDICATOR_CODE.previous_year;
          }
          return arr.concat([wpv_indicator_code, cvdpv_indicator_code].map(indicatorCode => {
            return inRange.filter(x => x.IndicatorCode === indicatorCode);
          }).map(x => x.length));
        }, [])).concat(formatDate(lastWPV), formatDate(lastCVDPV));
      });

    countryTable
      .append("tbody")
      .selectAll("tr")
      .data(countryGridBody)
      .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
          .append("td")
          .html(d => d);
  });
  


// WEBPACK FOOTER //
// ./src/index.js